import { alpha, Box, Stack, Typography } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ItemProgressProps as Props } from './types';

export const ItemProgress = memo(({ className, item }: Props) => {
  const { color, percent, title, value } = item;

  return (
    <Styled.Wrapper
      className={classnames('ItemProgress', className)}
      sx={SX.root}
      gap={1}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={SX.title}>{title}</Typography>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          gap={0.5}
        >
          <Typography sx={SX.value}>{value}</Typography>
          <Typography sx={SX.percent}>({percent}%)</Typography>
        </Stack>
      </Stack>
      <Box
        sx={{
          width: '100%',
          height: (p) => p.spacing(0.5),
          borderRadius: '2px',
          background: alpha(color, 0.2),
        }}
      >
        <Box
          sx={{
            width: `${+percent}%`,
            height: '100%',
            borderRadius: '2px',
            background: color,
          }}
        />
      </Box>
    </Styled.Wrapper>
  );
});

ItemProgress.displayName = 'ItemProgress';
